import { render, staticRenderFns } from "./OneModelCard.vue?vue&type=template&id=666e9086&scoped=true"
import script from "./OneModelCard.vue?vue&type=script&lang=js"
export * from "./OneModelCard.vue?vue&type=script&lang=js"
import style0 from "./OneModelCard.vue?vue&type=style&index=0&id=666e9086&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "666e9086",
  null
  
)

export default component.exports